import { gatewayInstance } from "../server/gateway";

// 客户端-用户是否有未浏览市场应用
export async function hasNewStoreApplication() {
  return gatewayInstance.request({
    api: "appstore.hasNewStoreApplication",
    method: "POST"
  });
}
